<template>
	<div class="serive-tek">
		<div class="myimg">
			<top-image :myimg="myimg"></top-image>
		</div>
		<div class="radio-wrap">  
      <div class="radio-group" v-model="tabView">  
      <span>{{tesv}}</span> 
        <span 
           v-for="(tab ,index) in tabs" 
           :class="{cur:iscur==index}" @click="iscur=index,tabChange('select' + (index + 1))">
             {{tab.name}}
        </span>  
      </div>  
      <div class="keep-alive"> 
	      <keep-alive>   
	        <component v-bind:is="tabView"></component>  
	      </keep-alive>   
	    </div> 
    </div>  

	</div>

</template>

<script type="text/ecmascript-6">
	import TopImage from 'components/top-image/top-image'
	import select1 from 'components/tab-item/first-introduce'
	import select2 from 'components/tab-item/second-company'
	import select3 from 'components/tab-item/qa-question'
	import select4 from 'components/tab-item/online-back'

	export default {
		data() {
			return {
				myimg: 'serive-tek',
				tabView: 'select1',
        iscur: 0
			}
		},
		components:{
			TopImage,
			select1,  
	    select2,  
	    select3,
	    select4
		},
		methods: {  
    tabChange:function(tab){  
      this.tabView = tab;  
	    }  
	  },
	  computed: {
	  	tabs() {
	  		return this.$t('tabs')
	  	},
			tesv() {
				return this.$t('tesv')
			}
	  }  
	}
</script>

<style scroped lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"
	
	.serive-tek
		color: $color-theme
		.radio-wrap
			display: flex
			margin: 160px auto
			@media screen and (max-width:550px)
				margin: 50px auto
			.radio-group
				width: 30%
				height: 150px
				flex: 3
				display: flex
				flex-direction: column
				padding: 0 30px 0 60px
				@media screen and (max-width:550px)
					padding: 0 10px 0 20px
					flex: 4
					height: 120px
				span
					flex: 1
					font-size: $font-web-small
					border: 1px solid $color-text-m
					border-bottom: none
					text-align: center
					box-sizing: border-box
					padding: 3px 5px
					line-height: 30px
					@media screen and (max-width:550px)
						font-size: $font-web-small-s
						line-height: 25px
				span:nth-child(1)
					background: $color-theme
					color: $color-text-m
				span:nth-child(5)
					border: 1px solid $color-text-m
				.cur
					background: $color-text-m
					color: $color-text
			.keep-alive
				margin: 0 60px 0 30px
				margin-top: -30px
				flex: 8
				@media screen and (max-width:550px)
					margin: 0 30px 0 15px
					margin-top: -30px
</style>



// WEBPACK FOOTER //
// src/components/serive-tek/serive-tek.vue